module.exports = __webpack_public_path__ + "static/apple-icon-152x152-cc1923c280b1043f83b256ff3994071b.png";